import { FC } from "react";
import {
  MoneyMask,
  EmailMask,
  numberMask,
  valortotalDocumentosSeleccionados,
} from "../../helpers";
import { Iestado, respuestaEpayco } from "../../helpers/dataExamples";

type props = {
  descrip: string;
  limite: string;
  valor: string | number;
  correo: string;
  telefono: string;
  nombres: string;
  apellidos: string;
};

type props2 = {
  estado: Iestado;
};

type props3 = {
  resultadoPago: respuestaEpayco;
};

const DetailPago: FC<props> = ({
  descrip,
  limite,
  valor,
  correo,
  telefono,
  nombres,
  apellidos,
}) => {
  return (
    <>
      <div className="row mt-3">
        <div className="col">
          <label className="etiqueta_oculta">Descripción pago</label>
          <input
            type="text"
            className="form-control form-control-solid form-control-sm"
            id="descripcion"
            maxLength={20}
            placeholder="Referencia de Pago"
            value={descrip}
          ></input>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col">
          <label className="etiqueta_oculta">limite pago</label>
          <input
            type="text"
            className="form-control form-control-solid form-control-sm"
            id="descripcion"
            maxLength={20}
            placeholder="Referencia de Pago"
            value={limite}
            readOnly
          ></input>
        </div>

        <div className="col">
          <label className="etiqueta_oculta">Valor a pagar</label>
          <input
            type="text"
            className="form-control form-control-solid form-control-sm"
            id="descripcion"
            maxLength={20}
            placeholder="Referencia de Pago"
            value={valor}
            readOnly
          ></input>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col">
          <label className="etiqueta_oculta">Correo electrónico</label>
          <input
            type="text"
            className="form-control form-control-solid form-control-sm"
            id="descripcion"
            maxLength={20}
            placeholder="Referencia de Pago"
            value={correo}
            readOnly
          ></input>
        </div>

        <div className="col">
          <label className="etiqueta_oculta">Telefono</label>
          <input
            type="text"
            className="form-control form-control-solid form-control-sm"
            id="descripcion"
            maxLength={20}
            placeholder="Referencia de Pago"
            value={telefono}
            readOnly
          ></input>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col">
          <label className="etiqueta_oculta">Nombres</label>
          <input
            type="text"
            className="form-control form-control-solid form-control-sm"
            id="descripcion"
            maxLength={20}
            placeholder="Referencia de Pago"
            value={nombres}
            readOnly
          ></input>
        </div>

        <div className="col">
          <label className="etiqueta_oculta">Apellidos</label>
          <input
            type="text"
            className="form-control form-control-solid form-control-sm"
            id="descripcion"
            maxLength={20}
            placeholder="Referencia de Pago"
            value={apellidos}
            readOnly
          ></input>
        </div>
      </div>
    </>
  );
};

const DetailPago2: FC<props> = ({
  descrip,
  limite,
  valor,
  correo,
  telefono,
  nombres,
  apellidos,
}) => {
  return (
    <>
      <div className="row mt-3">
        <div className="col">
          <label className="etiqueta_oculta">Descripción pago</label>
          <input
            type="text"
            className="form-control form-control-solid rounded-pill"
            id="descripcion"
            maxLength={20}
            placeholder="Referencia de Pago"
            value={descrip}
            readOnly
          ></input>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col">
          <label className="etiqueta_oculta">limite pago</label>
          <input
            type="text"
            className="form-control form-control-solid rounded-pill"
            id="descripcion"
            maxLength={20}
            placeholder="Referencia de Pago"
            value={limite}
            readOnly
          ></input>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col">
          <label className="etiqueta_oculta">Valor a pagar</label>
          <input
            type="text"
            className="form-control form-control-solid rounded-pill"
            id="descripcion"
            maxLength={20}
            placeholder="Referencia de Pago"
            value={valor}
            readOnly
          ></input>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col">
          <label className="etiqueta_oculta">Correo electrónico</label>
          <input
            type="text"
            className="form-control form-control-solid rounded-pill"
            id="descripcion"
            maxLength={20}
            placeholder="Referencia de Pago"
            value={correo}
            readOnly
          ></input>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col">
          <label className="etiqueta_oculta">Telefono</label>
          <input
            type="text"
            className="form-control form-control-solid rounded-pill"
            id="descripcion"
            maxLength={20}
            placeholder="Referencia de Pago"
            value={telefono}
            readOnly
          ></input>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col">
          <label className="etiqueta_oculta">Nombres</label>
          <input
            type="text"
            className="form-control form-control-solid rounded-pill"
            id="descripcion"
            maxLength={20}
            placeholder="Referencia de Pago"
            value={nombres}
            readOnly
          ></input>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col">
          <label className="etiqueta_oculta">Apellidos</label>
          <input
            type="text"
            className="form-control form-control-solid rounded-pill"
            id="descripcion"
            maxLength={20}
            placeholder="Referencia de Pago"
            value={apellidos}
            readOnly
          ></input>
        </div>
      </div>
    </>
  );
};

const DetailPago3: FC<props2> = ({ estado }) => {
  const email = EmailMask(estado.correo);
  return (
    <>
      <div className="row mt-3">
        <div className="col">
          {/*<label className='etiqueta_oculta'>Tipo de documento:</label>*/}
          <select
            className="form-select rounded-pill"
            id="select_tipo_doc"
            value={estado.tipoDocumento}
            disabled={true}
          >
            <option value="T.I">T.I - Tarjeta de Identidad</option>
            <option value="R.E">R.E - Registro Civil</option>
            <option value="NIT">NIT - NIT</option>
            <option value="C.E">C.E - Cedula de Extranjeria</option>
            <option value="C.C">C.C - Cedula de Ciudadania</option>
          </select>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col">
          {/*<label className='etiqueta_oculta'>Numero de documento:</label>*/}
          <input
            type="text"
            className="form-control form-control-lg rounded-pill"
            id="input_documento"
            maxLength={14}
            placeholder="Numero de documento"
            value={estado.documento}
            disabled={true}
          ></input>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col">
          {/*<label className='etiqueta_oculta'>Nombres</label>*/}
          <input
            type="text"
            className="form-control form-control-solid rounded-pill"
            id="descripcion"
            maxLength={20}
            placeholder="Nombres"
            value={estado.nombres}
            readOnly
          ></input>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col">
          {/*<label className='etiqueta_oculta'>Apellidos</label>*/}
          <input
            type="text"
            className="form-control form-control-solid rounded-pill"
            id="descripcion"
            maxLength={20}
            placeholder="Apellidos"
            value={estado.apellidos}
            readOnly
          ></input>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col">
          {/*<label className="etiqueta_oculta">Correo electrónico</label>*/}
          <input
            type="text"
            className="form-control form-control-solid rounded-pill"
            id="descripcion"
            maxLength={20}
            placeholder="Email"
            value={email}
            readOnly
          ></input>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col">
          {/*<label className="etiqueta_oculta">Telefono</label>*/}
          <input
            type="text"
            className="form-control form-control-solid rounded-pill"
            id="descripcion"
            maxLength={20}
            placeholder="Telefono"
            value={numberMask(estado.telefono)}
            readOnly
          ></input>
        </div>
      </div>
    </>
  );
};

const ResumenPago: FC<props2> = ({ estado }) => {
  let money = valortotalDocumentosSeleccionados(estado);
  let refActiva = estado.referenciaActiva;
  return (
    <div id="resumenDelPago" className="m-4">
      <div className="row">
        <div className="col">
          <h5>Pago de servicios</h5>
          <p>
            {refActiva === ""
              ? ""
              : estado.referencias[estado.referenciaActiva].descrip}
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <h5>Referencia de pago</h5>
          <p>{estado.referenciaActiva}</p>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <h5>Vence</h5>
          <p>
            {refActiva === ""
              ? ""
              : estado.referencias[estado.referenciaActiva].limite}
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <h5>Total a pagar</h5>
          <p className="text-comfe text-end fs-1 fw-bolder">
            ${MoneyMask(money + "")}
          </p>
        </div>
      </div>
    </div>
  );
};

const ResultadoTransaccion: FC<props3> = ({ resultadoPago }) => {
  return (
    <>
      <div className="row mt-1 fs-5">
        <div className="col-md-6">Fecha de pago</div>
        <div className="col-md-6 text-end">
          {resultadoPago.x_transaction_date}
        </div>
      </div>
      <div className="row mt-1 fs-5">
        <div className="col-md-6">Descripción</div>
        <div className="col-md-6 text-end">{resultadoPago.x_description}</div>
      </div>
      <div className="row mt-1 fs-5">
        <div className="col-md-6">Ref. Comercio</div>
        <div className="col-md-6 text-end">{resultadoPago.x_id_factura}</div>
      </div>
      <div className="row mt-1 fs-5">
        <div className="col-md-6">Ref. Epayco</div>
        <div className="col-md-6 text-end">{resultadoPago.x_ref_payco}</div>
      </div>
      <div className="row mt-1 fs-5">
        <div className="col-md-6">Método de pago</div>
        <div className="col-md-6 text-end">
          {resultadoPago.x_franchise + " - " + resultadoPago.x_bank_name}
        </div>
      </div>
      <div className="row mt-1 fs-5">
        <div className="col-md-6">Autorización / CUS</div>
        <div className="col-md-6 text-end">{resultadoPago.x_approval_code}</div>
      </div>
      <div className="row mt-1 fs-5">
        <div className="col-md-6">Recibo</div>
        <div className="col-md-6 text-end">
          {resultadoPago.x_transaction_id}
        </div>
      </div>
      <div className="row mt-1 fs-5">
        <div className="col-md-6">Documento de pago</div>
        <div className="col-md-6 text-end">{resultadoPago.x_extra1}</div>
      </div>
      <div className="row mt-1 fs-5">
        <div className="col-md-6">Total</div>
        <div className="col-md-6 text-end">
          <b>${MoneyMask(resultadoPago.x_amount_ok + "")}</b>
        </div>
      </div>
      <div
        className={
          "row mt-10 fs-5 " +
          (resultadoPago.x_response === "Aceptada" ? "" : " d-none")
        }
      >
        <div className="col-md-12 text-center">
          <p>
            {/*Gracias, su compra se ha realizado con éxito y su orden ha sido
            procesada.*/}
            Gracias, su compra se ha realizado con éxito y su orden esta siendo
            procesada.
          </p>
        </div>
      </div>
    </>
  );
};

export {
  DetailPago,
  DetailPago2,
  DetailPago3,
  ResumenPago,
  ResultadoTransaccion,
};
